import { Typography } from "@mui/material";
import React from "react";

const ErrorText = ({ text }) => {
  return <Typography color="error">{text}</Typography>;
};

export default ErrorText;
